"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var schema_typed_1 = require("schema-typed");
var StringTypeAdaptor_1 = __importDefault(require("./adaptors/StringTypeAdaptor"));
var ArrayTypeAdaptor_1 = __importDefault(require("./adaptors/ArrayTypeAdaptor"));
var ObjectTypeAdaptor_1 = __importDefault(require("./adaptors/ObjectTypeAdaptor"));
var RulesParser_1 = __importDefault(require("./RulesParser"));
var NumberTypeAdaptor_1 = __importDefault(require("./adaptors/NumberTypeAdaptor"));
var BooleanTypeAdaptor_1 = __importDefault(require("./adaptors/BooleanTypeAdaptor"));
var DateTypeAdaptor_1 = __importDefault(require("./adaptors/DateTypeAdaptor"));
var messages_1 = __importDefault(require("./messages"));
var Validator = /** @class */ (function () {
    function Validator(rules, messages) {
        Validator.$booted = true;
        this.$rawRules = rules;
        this.$messageBag = messages;
        this.parseRules();
        this.makeSchemaModel();
    }
    Validator.make = function (rules, messages) {
        return new Validator(rules, messages);
    };
    Validator.SchemaModel = function (rules, messages) {
        return this.make(rules, messages).getSchemaModel();
    };
    Validator.check = function (data, rules, messages) {
        return this.make(rules, messages).check(data);
    };
    Validator.messages = function (messages) {
        if (Validator.$booted) {
            console.warn("Validator.messages() won't take effect in Validator instances created before it's called. You may want to call it in advance.");
        }
        if (messages) {
            this.$globalMessageBag = this.mergeMessageBag(this.$globalMessageBag, messages);
        }
    };
    Validator.mergeMessageBag = function (origin, messages) {
        return __assign(__assign(__assign({}, origin), messages), { fields: __assign(__assign({}, origin.fields), messages === null || messages === void 0 ? void 0 : messages.fields) });
    };
    Validator.prototype.check = function (data) {
        // fixme use types from schema-typed directly in future updates
        return this.getSchemaModel().check(data);
    };
    Validator.prototype.getRawRules = function () {
        return this.$rawRules;
    };
    Validator.prototype.getParsedRules = function () {
        return this.$parsedRules;
    };
    Validator.prototype.getMessageBag = function () {
        return Validator.mergeMessageBag(Validator.$globalMessageBag, this.$messageBag);
    };
    Validator.prototype.parseRules = function () {
        this.$parsedRules = RulesParser_1.default.parse(this.getRawRules());
    };
    Validator.prototype.makeSchemaModelSchema = function () {
        return this.parsedTypeRuleMap(this.getParsedRules());
    };
    Validator.prototype.parsedTypeRuleMap = function (input) {
        var _this = this;
        return Object.keys(input).reduce(function (acc, field) {
            acc[field] = _this.newAdaptorForRule(input[field]).getSchemaType();
            return acc;
        }, {});
    };
    Validator.prototype.newAdaptorForRule = function (_a) {
        var fieldName = _a.path, type = _a.type, rules = _a.rules, rule = __rest(_a, ["path", "type", "rules"]);
        var adaptor;
        switch (type) {
            case "number":
                adaptor = new NumberTypeAdaptor_1.default(fieldName, this);
                break;
            case "array":
                adaptor = new ArrayTypeAdaptor_1.default(fieldName, this);
                if ("of" in rule) {
                    adaptor.setItemAdaptor(this.newAdaptorForRule(rule.of));
                }
                break;
            case "object":
                adaptor = new ObjectTypeAdaptor_1.default(fieldName, this);
                if ("shape" in rule) {
                    adaptor.getSchemaType().shape(this.parsedTypeRuleMap(rule.shape));
                }
                break;
            case "boolean":
                adaptor = new BooleanTypeAdaptor_1.default(fieldName, this);
                break;
            case "date":
                adaptor = new DateTypeAdaptor_1.default(fieldName, this);
                break;
            case "string":
            default:
                adaptor = new StringTypeAdaptor_1.default(fieldName, this);
                break;
        }
        return adaptor.applyRules(rules);
    };
    Validator.prototype.makeSchemaModel = function () {
        this.$schemaModel = (0, schema_typed_1.SchemaModel)(this.makeSchemaModelSchema());
    };
    Validator.prototype.getSchemaModel = function () {
        return this.$schemaModel;
    };
    /**
     * 记录是否已经创建 Validator 实例，用于在设置语言包时给出警告
     */
    Validator.$booted = false;
    Validator.$globalMessageBag = messages_1.default;
    return Validator;
}());
exports.default = Validator;
